import { createSignal } from "solid-js"
import type { TileGraphCorner } from "../../lib/core/engine/TileGraphCorner/TileGraphCorner.type"
import { immutableEmptyArray } from "../../lib/lib"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useTileCornerListSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Array<TileGraphCorner>>(immutableEmptyArray as unknown as Array<TileGraphCorner>)

  return signal
})


